import React from 'react'
import ShopAreaSelection from 'components/screens/ShopAreaSelection'

export default function ShopAreaSelectionContainer() {
  return <ShopAreaSelection />
}
